exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-6e9f9fb3]{padding:1em}.card pre[data-v-6e9f9fb3]{overflow-y:scroll;height:63vh}", ""]);

// exports
